export const ErrorCodes = {
    UNKNOWN: 'unknown',
    UPLOAD_FILE_ERROR: 'upload-file-error',
    SESSION_ID_ERROR: 'session-id-error',
    SUPPORT_CASE_MISMATCH_ERROR: 'support-case-mismatch-error',
    DOWNLOAD_TRANSCRIPT_ERROR: 'download-transcript-error',
    SECURE_FORM_ALREADY_SUBMITTED: 'secure-form-already-submitted',
};
//# sourceMappingURL=ErrorCodes.js.map